import {monitorFormInputs} from './form-saturation'
import {forEachNode, q, qa, hasGoodConnection, injectLink} from "./dom-utils";
import {initDynamicBackground} from "./dynamic-background--switching"
import {initPulse} from "./pulse"
import {initGracefulAutofill} from "./form-autofill-heuristics";
import {initGalleries} from "./galleries";
import {handleSubmit} from "./forms";
import {navHighlight} from "./nav-highlight";


const jsConf = ('jsConf' in window) ? window.jsConf : {}


function onFeatures() {
    initDynamicBackground()
    initGalleries()
}

function onLanding() {
    initDynamicBackground()
    initPulse()
    initGalleries()
    //monitorFormInputs()
    //initGracefulAutofill()
    q('.form').addEventListener('submit', handleSubmit)
}

function onSignin() {
    console.debug('main.js : onSignin')
    monitorFormInputs()
    initGracefulAutofill()
    q('.form--signin').addEventListener('submit', handleSubmit)
}

function onSignup() {
    console.debug('main.js : onSignup')
    monitorFormInputs()
    initGracefulAutofill()
    q('.form--signup').addEventListener('submit', handleSubmit)
}

function onResetPassword() {
    console.debug('main.js : onResetPassword')
    monitorFormInputs()
    initGracefulAutofill()
    q('.form').addEventListener('submit', handleSubmit)
}

function onUserGuide() {
    navHighlight()
}

const scenarios = {
    signin: onSignin,
    signup: onSignup,
    features: onFeatures,
    main: onLanding,
    'user-guide': onUserGuide,
    'reset-password': onResetPassword
}


function scheduleReveals() {
    const elems = qa('[data-reveal-delay]')
    forEachNode(elems, (node) => {
        const delay = parseInt(node.dataset.revealDelay) || 10
        setTimeout(() => {
            node.classList.add('g-reveal--allowed')
        }, delay)
    })
}


function initCookieNotice() {
    const cn = q('.cookie-notice')
    if (!cn) { return }
    const consentGiven = /cconsent/.test(document.cookie)
    const offerBadge = q('.offer-badge')
    if (consentGiven || offerBadge) {
        cn.remove()
        return
    }
    const cns = cn.querySelector('.cookie-notice__agree')
    cns.onclick = () => {
        const expires = (new Date(Date.now() + 1000 * 60 * 60 * 24 * 365)).toUTCString()
        document.cookie = 'cconsent="true"; path=/'
            + (location.protocol === "https:" ? ';Secure' : '')
            + ';expires=' + expires;
        initCookieNotice()
    }
}

function initOfferBadge() {
    const cn = q('.offer-badge')
    if (!cn) { return }
    const consentGiven = /__offer-closed/.test(document.cookie)
    if (consentGiven) {
        cn.remove()
        return
    }
    const cns = cn.querySelector('.offer-badge__close')
    cns.onclick = () => {
        const expires = (new Date(Date.now() + 1000 * 60 * 60 * 24 * 365)).toUTCString()
        document.cookie = '__offer-closed="true"; path=/'
            + (location.protocol === "https:" ? ';Secure' : '')
            + ';expires=' + expires;
        initOfferBadge()
    }
}


function onTrackedClick(evt) {
}

function trackClicks() {
    const trackedElements = qa('[data-target-id]')
    forEachNode(trackedElements, (el) => el.addEventListener('click', onTrackedClick, true))
}

function autoPrefetch(force) {
    const prefetchHref = jsConf.urlDemoJs
    if (force || prefetchHref && hasGoodConnection()) {
        console.info('main.js : autoPrefetch : will load ', prefetchHref)
        injectLink({ rel: 'prefetch', href: prefetchHref })
    } else {
        console.info('main.js : autoPrefetch : skipped')
    }
}
// window.autoPrefetch = autoPrefetch


function getConf() {
    const conf = {
        goodConnection: hasGoodConnection()
    }
    return conf
}


function onDomReady() {
    console.info('main.js : conf', getConf())

    scheduleReveals()
    initCookieNotice()
    initOfferBadge()

    setTimeout(autoPrefetch, 3000)
    // trackClicks()
    const scenId = document.documentElement.dataset.scenarioId
    const scenario = scenarios[scenId]
    if (scenario) {
        console.info('main.js : scenario', scenId)
        scenario();
    } else {
        console.info('main.js : scenario script not found', scenId)
    }
}


const intId = setInterval(() => {
    console.debug('main.js : monitoring document ready state')
    if (!['complete','interactive'].includes(document.readyState)) {
        return
    }
    console.debug('main.js : dom ready')
    clearInterval(intId)
    onDomReady()
}, 10)
